/**
 * Fallback neutro quando env, backend ou settings do tenant não definem nome.
 * Nome "de verdade" vem de REACT_APP_APP_NAME / manifest no build e de public-settings em runtime.
 */
export const DEFAULT_APP_DISPLAY_NAME = 'App';

export const DEFAULT_APP_DESCRIPTION = 'Atendimento e gestão de conversas em um só lugar';
